import Header from "./parts/NavigationHeading";
import Form from "./parts/GetStartedForm";
import TopRated from "./parts/TopRated";
import Hero from "./parts/Hero";
import Footer from "./parts/Footer";

const Home = () => {
  return (<>
  <Header />
    <main>
      <Hero />
      <Form />
      <TopRated /> 
      <Footer />
    </main>
    </>
  );
};

export default Home;
